import { useWorkspaceProvisioning } from '../features/rooms/useWorkspaceProvisioning';

/**
 * Headless component that runs the one-time, on-login workspace provisioning
 * (auto-select the user's room, or first-run create-room-with-defaults). Renders
 * nothing — it exists so the provisioning hook runs inside the router + provider
 * tree. Mounted once inside the authenticated area of the app shell.
 */
export function WorkspaceBootstrap() {
  useWorkspaceProvisioning();
  return null;
}

export default WorkspaceBootstrap;
